module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"found":"{count} found"},"no":{"found":"{count} treff"}}')
  delete Component.options._Ctor
}
